import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { TailSpin } from "react-loader-spinner";

export const PrimaryButton = (props) => {
  const { t } = useTranslation();
  const {
    click,
    title,
    fullWidth,
    padding,
    borderRadius,
    textTransform,
    disabled,
    color,
    margin,
    boxShadow,
    bgColor,
    isLoading,
    fontSize = "13px",
    width,
    fontWeight,
    ...rest
  } = props;
  return (
    <Button
      fullWidth={fullWidth}
      variant="contained"
      type="submit"
      disabled={disabled}
      sx={{
        color: color ? color : "color.black",
        padding: padding ? padding : "0.8rem",
        bgcolor: bgColor ? bgColor : "color.magentaLight2",
        borderRadius: borderRadius ? borderRadius : 1,
        fontSize: fontSize,
        width: width ? width : "auto",
        fontWeight: fontWeight || "bold",
        boxShadow: `${boxShadow > -1 ? boxShadow : "none !important"}`,
        "&:hover": {
          bgcolor: "color.magentaLight2",
        },
        textTransform: textTransform,
        margin: margin ? margin : "0px",
      }}
      onClick={click}
      {...rest}
    >
      {isLoading ? (
        <>
          <TailSpin color="#000000" height={30} width={60} />
        </>
      ) : (
        title || t("next")
      )}
    </Button>
  );
};

export const SecondaryButton = (props) => {
  const { t } = useTranslation();
  const {
    type,
    click,
    title,
    width,
    minWidth,
    textAlign,
    padding,
    border,
    borderRadius,
    fontSize,
    fontWeight,
    marginLeft,
    marginTop,
    bgColor,
    hoverBgColor,
    textTransform,
    disabled,
    isLoading,
    color,
    height,
    pointerEvents,
    position,
    right,
    top,
    ...rest
  } = props;

  return (
    <Button
      type={type}
      variant="outlined"
      sx={{
        color: color ? color : "color.brown",
        padding: padding ? padding : "0.8rem",
        fontWeight: fontWeight ? fontWeight : "bold",
        fontSize: fontSize ? fontSize : "0.875rem",
        border: border ? border : "1px solid #c298bb",
        borderRadius: borderRadius ? borderRadius : 1,
        marginLeft: marginLeft ? marginLeft : "0",
        marginTop: marginTop ? marginTop : "0",
        bgcolor: disabled ? "#707070" : bgColor || "color.transparent",
        width: width ? width : "auto",
        minWidth: minWidth ? minWidth : "auto",
        textAlign: textAlign ? textAlign : "center",
        height: height ? height : "auto",
        "&:hover": {
          bgcolor: hoverBgColor ? hoverBgColor : "color.transparent",
          border: border ? border : "1px solid #c298bb",
        },
        textTransform: textTransform ? textTransform : "uppercase",
        pointerEvents: pointerEvents ? pointerEvents : "all",
        position: position ? position : "relative",
        right: right ? right : "0",
        top: top ? top : "0",
      }}
      onClick={click}
      disabled={disabled}
      {...rest}
    >
      {isLoading ? (
        <>
          <TailSpin color="#dfc8db" height={30} width={60} />
        </>
      ) : (
        title || t("back")
      )}
    </Button>
  );
};

export const LinkButton = (props) => {
  const {
    type,
    click,
    title,
    width,
    textAlign,
    padding,
    border,
    borderRadius,
    fontSize,
    fontWeight,
    marginLeft,
    marginTop,
    bgColor,
    textTransform,
    disabled,
    isLoading,
  } = props;
  return (
    <Button
      type={type}
      variant="outlined"
      sx={{
        color: "color.brown",
        padding: padding ? padding : "0.8rem",
        fontWeight: fontWeight ? fontWeight : "400",
        fontSize: fontSize ? fontSize : "0.875rem",
        border: border ? border : "1px solid #c298bb",
        borderRadius: borderRadius ? borderRadius : 1,
        marginLeft: marginLeft ? marginLeft : "0",
        marginTop: marginTop ? marginTop : "0",

        bgcolor: disabled ? "#707070" : bgColor || "color.transparent",
        width: width ? width : "auto",
        textAlign: textAlign ? textAlign : "center",
        textTransform: textTransform ? textTransform : "uppercase",
        "&:hover": {
          border: border ? border : "none",
        },
      }}
      onClick={click}
      disabled={disabled}
    >
      {isLoading ? (
        <>
          <TailSpin color="#dfc8db" height={30} width={60} />
        </>
      ) : (
        title
      )}
    </Button>
  );
};
